module.exports = __webpack_public_path__ + "img/Surface3.73d56b73.jpg";